/**
 * GNB 메뉴 노출 게이트.
 *
 * ─────────────────────────────────────────────────────────────
 * 왜 파일을 따로 뒀나
 * ─────────────────────────────────────────────────────────────
 * 검증 중인 기능이 전 센터에 그대로 노출되는 사고를 막는 장치입니다.
 * 실제로 '데일리 브리핑'은 최상위 메뉴로 붙었는데, 게이트가
 * **하위 메뉴에만** 걸려 있어서 배포하면 모든 센터에 바로 보이는
 * 상태였습니다. 화면을 띄워야만 알 수 있는 종류의 실수라,
 * 규칙만 떼어 내고 테스트를 붙였습니다.
 */

export type GateFlags = {
    /** 슈퍼관리자 센터 기능이 열려 있는가 (= 프랜차이즈 산하 센터인가) */
    showSuperAdminCenterFeatures: boolean;
    /** 체험 계정인가 */
    isTrial: boolean;
    /**
     * 데일리 브리핑이 이 센터에 열려 있는가.
     *
     * ⚠️ **판정 전에는 반드시 false 를 넣으세요.** 선택 항목이 아니라 필수인 이유가
     *    이것입니다 — 빠뜨리면 컴파일이 깨지지, 조용히 열리지 않습니다.
     */
    opsBriefingEnabled: boolean;
};

export type GateableNav = {
    /**
     * 식별용. 판정에는 쓰지 않습니다.
     * 하위 메뉴 항목은 label 대신 name 을 쓰므로 선택 항목입니다 —
     * 최상위와 하위가 **같은 판정 함수**를 타야 한쪽에만 게이트가 빠지는 사고가 안 납니다.
     */
    label?: string;
    trialOnly?: boolean;
    superAdminCenterOnly?: boolean;
    opsBriefingOnly?: boolean;
};

/** 이 메뉴를 지금 보여줘도 되는가 */
export const canShowNav = (nav: GateableNav, flags: GateFlags): boolean => {
    if (nav.trialOnly && !flags.isTrial) return false;
    if (nav.superAdminCenterOnly && !flags.showSuperAdminCenterFeatures) return false;
    /*
     * 브리핑은 `superAdminCenterOnly` 와 **다른 값**을 봅니다.
     * 그 플래그는 "프랜차이즈 산하인가"라서 전체 센터의 약 절반이 해당됩니다.
     * 그걸 재사용하면 배포하는 순간 절반의 센터에 열리고, 게다가 PT팀 기능과
     * 롤아웃이 한 값에 묶여 하나를 켜면 다른 하나도 같이 켜집니다.
     */
    if (nav.opsBriefingOnly && !flags.opsBriefingEnabled) return false;
    return true;
};
